import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const API = process.env.REACT_APP_BACKEND_URL;
const SID_KEY = 'skk_sid';
const ENTRY_KEY = 'skk_entry_sent';

const getSid = () => {
  let sid = sessionStorage.getItem(SID_KEY);
  if (!sid) {
    sid = (window.crypto?.randomUUID?.() || `${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`);
    sessionStorage.setItem(SID_KEY, sid);
  }
  return sid;
};

const device = () => (window.innerWidth < 768 ? 'mobile' : window.innerWidth < 1024 ? 'tablet' : 'desktop');

const isStaff = () => {
  try {
    const u = JSON.parse(localStorage.getItem('user') || 'null');
    return u && ['admin', 'mitarbeiter'].includes(u.role);
  } catch {
    return false;
  }
};

/** Anonymer Seitenaufruf-Zähler (kein Cookie, keine IP) – nur öffentliche Seiten, keine eigenen Team-Zugriffe. */
export const PageviewTracker = () => {
  const { pathname } = useLocation();
  const last = useRef('');
  useEffect(() => {
    if (last.current === pathname) return;
    last.current = pathname;
    if (pathname.startsWith('/portal') || pathname.startsWith('/admin') || isStaff()) return;
    const entry = !sessionStorage.getItem(ENTRY_KEY);
    const body = JSON.stringify({ path: pathname, sid: getSid(), device: device(), ref: entry ? document.referrer || '' : '', entry });
    sessionStorage.setItem(ENTRY_KEY, '1');
    fetch(`${API}/api/analytics/pageview`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body, keepalive: true }).catch(() => {});
  }, [pathname]);
  return null;
};

export default PageviewTracker;
